import endpoints, { axios } from "../config/api";

function addTaskToProjectTemplate(templateId: number, taskId: number) {
  return axios.post(endpoints.projectTemplates.addTask(templateId), [taskId]);
}

export default addTaskToProjectTemplate;
